/**
 * Admin IAM rows from /api/users/me: UsersPrivileges or RolesPrivileges with nested Privilege + Resource.
 * Reviewers have privilege name "review" on resource "requests".
 */
export function hasRequestReviewPrivilege(privilegeRows) {
  if (!Array.isArray(privilegeRows)) {
    return false;
  }
  return privilegeRows.some((row) => {
    const p = row.Privilege || row.privilege;
    if (!p) return false;
    const r = p.Resource || p.resource;
    return p.name === 'review' && r && r.name === 'requests';
  });
}
